import packageConfig from "./../../package.json";
import { numberDotReg } from "@/utils/constant";

// 公共的路径前缀。构建时由流水线注入 PUBLIC_URL（如 /developer），未注入则视为根路径
const publicPath = process.env.PUBLIC_URL ?? packageConfig.homepage ?? "";
// 登录页面地址
const loginUrl = `${publicPath}/login`;
// 独立页面，不需要头尾
const alonePath = [`${publicPath}/login`, `${publicPath}/verify`];
// 展示未登录Header的页面
const unLoginHeader = [`${publicPath}/403`, `${publicPath}/forgot_password`, `${publicPath}/register_account`];
// 需要footer背景图的页面
const footerBgPath = [`${publicPath}/home`];
// 不需要footer的页面
const unFooterPath = [
  `${publicPath}`,
  `${publicPath}/`,
  `${publicPath}/staging`,
  `${publicPath}/app_detail`,
  `${publicPath}/app_list`,
  `${publicPath}/rules_list`,
  `${publicPath}/rules_detail`,
  `${publicPath}/super_device_template`,
  `${publicPath}/my_ai_model`,
  `${publicPath}/my_ai_model_detail`,
  `${publicPath}/my_device_plugin`,
  `${publicPath}/my_device_plugin_detail`,
  `${publicPath}/my_solution`,
  `${publicPath}/my_solution_detail`,
  `${publicPath}/product_manage`,
  `${publicPath}/product_detail`,
  `${publicPath}/agent`,
  `${publicPath}/agent_detail`,
  `${publicPath}/tool_box`,
  `${publicPath}/protocol_plugin`,
];
// 不需要登录的页面，取name
const unAuthPath = [
  // `${publicPath}/`,
  `${publicPath}/403`,
  `${publicPath}/login`,
  `${publicPath}/forgot_password`,
  `${publicPath}/register_account`,
  `${publicPath}/home`,
  `${publicPath}/ecological`,
  `${publicPath}/document_resources`,
  `${publicPath}/service_support`,
  `${publicPath}/document`,
  `${publicPath}/resource`,
  `${publicPath}/design`,
  `${publicPath}/design_story`,
];

// function normalizePath(path: string): string {
//   if (!path) return "/";
//   if (path === "/") return "/";
//   return path.replace(/\/+$/, "");
// }

// /**
//  * pathname 是否在给定路径白名单内（支持子路径匹配）
//  * 例如：/document 允许 /document/xxx；/ 不会误匹配其他路径
//  */
// function isPathAllowed(pathname: string, allowList: string[]): boolean {
//   const normalizedPathname = normalizePath(pathname);
//   return allowList.some((path) => {
//     const normalizedPath = normalizePath(path);
//     if (normalizedPath === "/") {
//       return normalizedPathname === "/";
//     }
//     return normalizedPathname === normalizedPath || normalizedPathname.startsWith(`${normalizedPath}/`);
//   });
// }
// 不需要登录的api
const unAuthApi = [
  `${publicPath}/message/code/common/sms/login`,
  `${publicPath}/login`,
  `${publicPath}/sms/login`,
  `${publicPath}/message/code/common/sms/register`,
  `${publicPath}/message/code/common/sms/reset/password`,
  `${publicPath}/user/register`,
  `${publicPath}/user/reset/password`,
  `${publicPath}/user/check/phone`,
  `${publicPath}/api/device/product/operatingSystem`,
  `${publicPath}/meta/api/gateway/device/detail/_query`,
];

/**
 * 这些路径及其子路径下点击 Logo 回门户根 `${publicPath || "/"}`，否则回工作台。
 * 范围：门户首页（含与首页同壳的页脚入口）以及从首页可点入的链路（如生态页及其 ModuleTabs 打开的 /resource、/docs 等）。
 * 不含工作台及其内部再打开的路径（如 staging 内开发文档 → sub-app），那些走工作台 Logo 逻辑。
 */
const toHomePath = [
  `${publicPath}/home`,
  `${publicPath}/ecological`,
  `${publicPath}/service_support`,
  `${publicPath}/document_resources`,
  `${publicPath}/resource`,
  `${publicPath}/docs`,
];

/** pathname 是否等于 segment 或为其子路径（如 …/service_support、…/service_support/foo），不会误匹配 …/service_supportExtra */
function pathnameMatchesSegmentOrDescendants(pathname: string, segment: string): boolean {
  const p = segment.replace(/\/+$/, "");
  if (!p) return false;
  return pathname === p || pathname.startsWith(`${p}/`);
}

function isLogoTargetPortalHome(pathname: string): boolean {
  const base = (publicPath || "").replace(/\/$/, "");
  if (base) {
    if (pathname === base || pathname === `${base}/`) return true;
  } else if (pathname === "/" || pathname === "") {
    return true;
  }
  return toHomePath.some((item) => pathnameMatchesSegmentOrDescendants(pathname, item));
}

// 需要整屏滚动的页面
const fullScreenScrolling = [`${publicPath}/`, `${publicPath}/home`];

const PROCESS_ENV_NODE: any = process.env.NODE_ENV;
const hostname = typeof window !== "undefined" ? window.location.hostname : "";

/** AI开发平台：开发 / 测试 / 生产环境对应不同链接 */
const AI_DEV_PLATFORM_ORIGINS = {
  dev: "https://agent-management-dev.kaihong.com/dev-web",
  test: "https://agent-management-test.kaihong.com/dev-web",
  prod: "https://agent-management-test.kaihong.com/dev-web",
} as const;

/** 根据当前访问域名返回 AI开发平台 链接（新窗口打开用） */
function getAiDevPlatformUrl(): string {
  if (typeof window === "undefined") return AI_DEV_PLATFORM_ORIGINS.prod;
  const h = window.location.hostname;
  if (h.includes("devdeveloper") || h === "localhost" || PROCESS_ENV_NODE === "development") {
    return AI_DEV_PLATFORM_ORIGINS.dev;
  }
  if (h.includes("testdeveloper") || h.includes("test")) {
    return AI_DEV_PLATFORM_ORIGINS.test;
  }
  return AI_DEV_PLATFORM_ORIGINS.prod;
}

const authCookieConfig = {
  expires: 7, // 有效期
  path: `${publicPath || "/"}/`, // path
  domain: PROCESS_ENV_NODE === `development` || numberDotReg.test(hostname) ? `` : `.kaihong.com`, // domain
};

export {
  publicPath,
  alonePath,
  loginUrl,
  unLoginHeader,
  footerBgPath,
  unFooterPath,
  unAuthPath,
  // isPathAllowed,
  unAuthApi,
  toHomePath,
  isLogoTargetPortalHome,
  fullScreenScrolling,
  authCookieConfig,
  PROCESS_ENV_NODE,
  getAiDevPlatformUrl,
};
